import { Helmet } from 'react-helmet';
import Breadcrumb, { BreadcrumbList } from './Breadcrumb';
import { TITLE } from '../config';
type HeaderProps = {
  title: string;
  breadcrumbs: BreadcrumbList[];
  action: JSX.Element | null;
};

const Header = (props: HeaderProps): JSX.Element => {
  return (
    <>
      <Helmet>
        <title>
          {props.title} - {TITLE}
        </title>
      </Helmet>
      <div className="main-header fixed top-0 right-0 z-50 flex flex-wrap justify-between items-center py-1.5 px-3 bg-white h-[60px] shadow-sm">
        <div className="flex flex-col h-full justify-between">
          <Breadcrumb list={props.breadcrumbs} />
          <h1 className="font-semibold text-xl text-gray-800">{props.title}</h1>
        </div>
        <div className="flex items-center justify-center">
          {props.action ? props.action : undefined}
        </div>
      </div>
    </>
  );
};

export default Header;
